module.exports = __webpack_public_path__ + "static/media/manu-1.b14821d0.png";